import {getMemoryListProvider} from 'views/programming/channel/contexts/getMemoryListProvider';
import {useFindQueueQuery} from 'features/channelQueue/channelQueueApi';
export const {MemoryListContext, MemoryListProvider, useMemoryListProvider} = getMemoryListProvider(useFindQueueQuery);
